/* SweetTooth — theme.js
   Cart AJAX | Cart Drawer | Toast | Nav | Scroll Reveal | Accordions | Parallax */

(function () {
  'use strict';

  /* ── Toast ── */
  var toastTimer = null;
  function showToast(msg) {
    var el = document.getElementById('st-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2400);
  }

  /* ── Cart State ── */
  var cartDrawerOpen = false;
  var cartDrawerClosing = false;

  /* ── Cart Drawer ── */
  function openCartDrawer() {
    var overlay = document.getElementById('cart-overlay');
    var drawer = document.getElementById('cart-drawer');
    if (!overlay || !drawer) return;
    cartDrawerClosing = false;
    overlay.classList.add('open');
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    cartDrawerOpen = true;
    fetchAndRenderCart();
  }

  function closeCartDrawer() {
    var overlay = document.getElementById('cart-overlay');
    var drawer = document.getElementById('cart-drawer');
    if (!overlay || !drawer || !cartDrawerOpen || cartDrawerClosing) return;

    cartDrawerClosing = true;
    cartDrawerOpen = false;
    document.body.style.overflow = '';
    overlay.classList.remove('open');
    drawer.classList.remove('open');

    drawer.addEventListener('transitionend', function onClose(e) {
      if (e.target !== drawer || e.propertyName !== 'transform') return;
      cartDrawerClosing = false;
    });
  }

  /* ── Shopify Cart API ── */
  function addToCart(variantId, qty, productTitle) {
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (cartRoot.charAt(cartRoot.length - 1) !== '/') cartRoot += '/';
    return fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        updateCartBadge();
      });
  }

  var cartChangeInFlight = false;

  function getCartChangeUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'cart/change.js';
  }

  function readCartControl(btn) {
    return {
      lineKey: btn.getAttribute('data-line-key'),
      line: parseInt(btn.getAttribute('data-line'), 10),
      qty: parseInt(btn.getAttribute('data-cart-qty'), 10)
    };
  }

  function buildCartChangePayload(lineKey, line, qty) {
    var payload = { quantity: qty };
    if (!isNaN(line) && line > 0) {
      payload.line = line;
    } else if (lineKey) {
      payload.id = lineKey;
    }
    return payload;
  }

  function setCartControlsDisabled(page, disabled) {
    if (!page) return;
    page.querySelectorAll('[data-line-key]').forEach(function (control) {
      control.disabled = disabled;
    });
  }

  function clearCartPageUpdating(page) {
    if (!page) return;
    page.classList.remove('is-updating');
    setCartControlsDisabled(page, false);
  }

  function updateCartLine(lineKey, qty, line) {
    var page = document.querySelector('[data-cart-page]');
    var payload = buildCartChangePayload(lineKey, line, qty);

    if (!('id' in payload) && !('line' in payload)) {
      clearCartPageUpdating(page);
      showToast(((window.__cartI18n || {}).updateError || 'Could not update cart'));
      return Promise.reject(new Error('Missing cart line identifier'));
    }

    if (cartChangeInFlight) return Promise.resolve();

    cartChangeInFlight = true;

    return fetch(getCartChangeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.data || !Array.isArray(result.data.items)) {
          var message = (result.data && (result.data.description || result.data.message)) || ((window.__cartI18n || {}).updateError || 'Could not update cart');
          throw new Error(message);
        }

        if (page) {
          window.location.reload();
          return;
        }

        renderCartDrawer(result.data);
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (b) {
          b.textContent = result.data.item_count;
          b.style.display = result.data.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function (e) {
        console.error('updateCart error', e);
        clearCartPageUpdating(page);
        showToast(e.message || ((window.__cartI18n || {}).updateError || 'Could not update cart'));
      })
      .finally(function () {
        cartChangeInFlight = false;
      });
  }

  function fetchCart(cb) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function (e) { console.error('fetchCart error', e); });
  }

  function formatMoney(cents) {
    return 'RM ' + (cents / 100).toFixed(2);
  }

  function updateCartBadge() {
    fetchCart(function (cart) {
      var badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(function (b) {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
  }

  function fetchAndRenderCart() {
    var itemsEl = document.getElementById('cart-drawer-items');
    var footerEl = document.getElementById('cart-drawer-footer');
    if (itemsEl) {
      itemsEl.innerHTML = '<div class="cart-loading"></div>';
      itemsEl.classList.remove('cart-items--updating');
    }
    if (footerEl) footerEl.style.display = 'none';
    fetchCart(function (cart) {
      renderCartDrawer(cart);
      var badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(function (b) {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
  }

  function renderCartDrawer(cart) {
    var titleEl = document.getElementById('cart-drawer-title');
    var itemsEl = document.getElementById('cart-drawer-items');
    var footerEl = document.getElementById('cart-drawer-footer');
    if (!itemsEl) return;
    itemsEl.classList.remove('cart-items--updating');

    var i18n = window.__cartI18n || {};
    var tTitle = i18n.title || 'Cart';
    var tTitleCount = i18n.titleCount || 'Cart (__n__)';
    var tEmpty = i18n.empty || 'Your cart is empty';
    var tDecrease = i18n.decrease || 'Decrease';
    var tIncrease = i18n.increase || 'Increase';
    var tRemove = i18n.remove || 'Remove';

    if (titleEl) {
      titleEl.textContent = cart.item_count > 0
        ? tTitleCount.replace('__n__', cart.item_count)
        : tTitle;
    }

    if (cart.items.length === 0) {
      itemsEl.innerHTML =
        '<div class="cart-empty">' +
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--caramel)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
        '<span class="cart-empty-text">' + tEmpty + '</span>' +
        '</div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, index) {
      var lineNum = index + 1;
      var imgUrl = item.featured_image && item.featured_image.url
        ? item.featured_image.url
        : '';
      html +=
        '<div class="cart-item">' +
        (imgUrl ? '<div class="cart-item-img"><img src="' + imgUrl + '" alt="' + item.product_title + '" loading="lazy"></div>' : '') +
        '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + item.product_title + '</div>' +
        '<div class="cart-item-size">370 ml / 12.5 oz</div>' +
        '<div class="cart-item-qty-row">' +
        '<button type="button" class="cart-qty-btn" data-line-key="' + item.key + '" data-line="' + lineNum + '" data-cart-qty="' + (item.quantity - 1) + '" aria-label="' + tDecrease + '">&#8722;</button>' +
        '<span class="cart-qty-val">' + item.quantity + '</span>' +
        '<button type="button" class="cart-qty-btn" data-line-key="' + item.key + '" data-line="' + lineNum + '" data-cart-qty="' + (item.quantity + 1) + '" aria-label="' + tIncrease + '">+</button>' +
        '<button type="button" class="cart-remove" data-line-key="' + item.key + '" data-line="' + lineNum + '" data-cart-qty="0" aria-label="' + tRemove + '">&#x2715;</button>' +
        '</div></div>' +
        '<span class="cart-item-price">' + formatMoney(item.line_price) + '</span>' +
        '</div>';
    });
    itemsEl.innerHTML = html;

    /* bind qty/remove buttons */
    itemsEl.querySelectorAll('[data-line-key][data-cart-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var control = readCartControl(btn);
        var qty = control.qty;
        if (isNaN(qty) || qty < 0) qty = 0;
        btn.classList.add('is-loading');
        itemsEl.classList.add('cart-items--updating');
        updateCartLine(control.lineKey, qty, control.line);
      });
    });

    /* render footer */
    if (footerEl) {
      footerEl.style.display = '';
      var subtotalEl = footerEl.querySelector('[data-subtotal]');
      var totalEl = footerEl.querySelector('[data-total]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    }
  }

  /* ── Nav ── */
  function initNav() {
    var nav = document.querySelector('.nav');
    var hamburger = document.getElementById('hamburger-btn');
    var mobileOverlay = document.getElementById('mobile-nav-overlay');
    var mobileDrawer = document.getElementById('mobile-drawer');
    var mobileClose = document.getElementById('mobile-drawer-close');

    /* scroll shadow */
    if (nav) {
      window.addEventListener('scroll', function () {
        nav.classList.toggle('scrolled', window.scrollY > 40);
      }, { passive: true });
    }

    /* hamburger */
    function openMobileNav() {
      if (mobileOverlay) mobileOverlay.classList.add('open');
      if (mobileDrawer) mobileDrawer.classList.add('open');
      if (hamburger) {
        hamburger.classList.add('is-open');
        hamburger.setAttribute('aria-expanded', 'true');
      }
      document.body.style.overflow = 'hidden';
    }
    function closeMobileNav() {
      if (mobileOverlay) mobileOverlay.classList.remove('open');
      if (mobileDrawer) mobileDrawer.classList.remove('open');
      if (hamburger) {
        hamburger.classList.remove('is-open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
      document.body.style.overflow = '';
    }

    if (hamburger) hamburger.addEventListener('click', openMobileNav);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);

    /* cart button */
    var cartBtn = document.getElementById('nav-cart-btn');
    if (cartBtn) cartBtn.addEventListener('click', openCartDrawer);

    /* escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeMobileNav();
        if (cartDrawerOpen) closeCartDrawer();
      }
    });
  }

  /* ── Cart drawer wiring ── */
  function initCartDrawer() {
    var overlay = document.getElementById('cart-overlay');
    var closeBtn = document.getElementById('cart-close-btn');
    if (overlay) overlay.addEventListener('click', closeCartDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  }

  /* ── Add-to-cart buttons (collection grid / featured cards) ── */
  function initAddToCartButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      var productTitle = btn.dataset.productTitle || '';
      if (!variantId) return;
      var orig = btn.textContent;
      btn.textContent = '✓';
      btn.classList.add('adding');
      addToCart(parseInt(variantId, 10), 1, productTitle)
        .then(function () { openCartDrawer(); })
        .catch(function (e) { console.error('addToCart error', e); });
      setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove('adding');
      }, 900);
    });
  }

  /* ── Product Detail Page ── */
  function initProductDetail() {
    /* qty controls */
    var qtyVal = document.getElementById('qty-val');
    var qtyMinus = document.getElementById('qty-minus');
    var qtyPlus = document.getElementById('qty-plus');

    if (qtyVal && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var v = Math.max(1, parseInt(qtyVal.textContent, 10) - 1);
        qtyVal.textContent = v;
      });
      qtyPlus.addEventListener('click', function () {
        var v = parseInt(qtyVal.textContent, 10) + 1;
        qtyVal.textContent = v;
      });
    }

    /* add-to-cart button */
    var pdpBtn = document.getElementById('pdp-add-to-cart');
    if (pdpBtn) {
      pdpBtn.addEventListener('click', function () {
        var variantId = pdpBtn.dataset.variantId;
        var qty = qtyVal ? parseInt(qtyVal.textContent, 10) : 1;
        if (!variantId) return;
        var origText = pdpBtn.textContent;
        pdpBtn.classList.add('is-loading');
        pdpBtn.disabled = true;
        addToCart(parseInt(variantId, 10), qty, pdpBtn.dataset.productTitle || '')
          .then(function () {
            pdpBtn.classList.remove('is-loading');
            pdpBtn.textContent = (window.__cartI18n || {}).added || '✓ Added!';
            pdpBtn.classList.add('added');
            setTimeout(function () {
              pdpBtn.textContent = origText;
              pdpBtn.classList.remove('added');
              pdpBtn.disabled = false;
            }, 1800);
          })
          .catch(function (e) {
            console.error('addToCart error', e);
            pdpBtn.classList.remove('is-loading');
            pdpBtn.textContent = origText;
            pdpBtn.disabled = false;
          });
      });
    }

    /* accordions */
    document.querySelectorAll('.accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.nextElementSibling;
        var arrow = btn.querySelector('.accordion-arrow');
        if (!body) return;
        var isOpen = body.classList.contains('open');
        /* close all */
        document.querySelectorAll('.accordion-body').forEach(function (b) { b.classList.remove('open'); });
        document.querySelectorAll('.accordion-arrow').forEach(function (a) { a.classList.remove('open'); });
        if (!isOpen) {
          body.classList.add('open');
          if (arrow) arrow.classList.add('open');
        }
      });
    });
  }

  /* ── Footer Accordion (mobile) ── */
  function initFooterAccordion() {
    document.querySelectorAll('.footer-accordion-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.nextElementSibling;
        var chevron = btn.querySelector('.footer-accordion-chevron');
        if (!body) return;
        var isOpen = body.classList.contains('is-open');
        body.classList.toggle('is-open', !isOpen);
        if (chevron) chevron.classList.toggle('is-open', !isOpen);
      });
    });
  }

  /* ── Scroll Reveal ── */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ── Language selector dropdown ── */
  function initLanguageSelectors() {
    var selectors = document.querySelectorAll('[data-language-selector]');
    if (!selectors.length) return;

    function closeSelector(selector) {
      var trigger = selector.querySelector('[data-language-trigger]');
      var menu = selector.querySelector('[data-language-menu]');
      if (!trigger || !menu) return;
      selector.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }

    function closeAllExcept(current) {
      selectors.forEach(function (selector) {
        if (selector !== current) closeSelector(selector);
      });
    }

    selectors.forEach(function (selector) {
      var trigger = selector.querySelector('[data-language-trigger]');
      var menu = selector.querySelector('[data-language-menu]');
      if (!trigger || !menu) return;

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = menu.hidden;
        closeAllExcept(selector);
        if (willOpen) {
          selector.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          menu.hidden = false;
        } else {
          closeSelector(selector);
        }
      });

      menu.addEventListener('click', function (e) {
        e.stopPropagation();
      });

      var options = menu.querySelectorAll('.language-selector__option');
      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (opt.classList.contains('is-active')) return;
          opt.classList.add('is-loading');
          var form = selector.querySelector('.language-selector__form');
          if (form) form.classList.add('language-selector__form--updating');
        });
      });
    });

    document.addEventListener('click', function () {
      selectors.forEach(closeSelector);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') selectors.forEach(closeSelector);
    });
  }

  /* ── Hero Parallax ── */
  function initHeroParallax() {
    var heroBg = document.getElementById('hero-bg');
    if (!heroBg) return;
    window.addEventListener('scroll', function () {
      heroBg.style.transform = 'scale(1.06) translateY(' + (window.scrollY * 0.25) + 'px)';
    }, { passive: true });
  }

  /* ── Cart page qty controls ── */
  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;

    page.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-key][data-cart-qty]');
      if (!btn || !page.contains(btn)) return;
      e.preventDefault();
      var control = readCartControl(btn);
      var qty = control.qty;
      if (isNaN(qty) || qty < 0) qty = 0;
      btn.classList.add('is-loading');
      var item = btn.closest('.cart-page__item');
      if (item) item.classList.add('cart-page__item--updating');
      page.classList.add('is-updating');
      setCartControlsDisabled(page, true);
      updateCartLine(control.lineKey, qty, control.line);
    });
  }

  function initFormLoaders() {
    var contactForm = document.getElementById('ContactForm');
    if (contactForm) {
      contactForm.addEventListener('submit', function () {
        var btn = contactForm.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-loading');
      });
    }

    var newsletterForm = document.getElementById('newsletter-form');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function () {
        var btn = newsletterForm.querySelector('[type="submit"]');
        if (btn) btn.classList.add('is-loading');
      });
    }
  }

  /* ── Init ── */
  function init() {
    initNav();
    initCartDrawer();
    initCartPage();
    initAddToCartButtons();
    initProductDetail();
    initFooterAccordion();
    initLanguageSelectors();
    initFormLoaders();
    initScrollReveal();
    initHeroParallax();
    updateCartBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
